<div container>
  <div ngbAccordion>
    <div ngbAccordionItem [collapsed]="true">
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <h3 class="mb-0">Background & Methodology</h3>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <p class="mb-3">
              This research was conducted by Wakefield Research
              (www.wakefieldresearch.com) via two survey instruments—one among
              1,000 US adults with type 1 diabetes and a second among 1,000 US
              caregivers to those under the age of 18 years with type 1
              diabetes, between March 15th and March 29th, 2024, using an email
              invitation and an online survey.
            </p>
            <p class="mb-3">
              Results of any sample are subject to sampling variation. The
              magnitude of the variation is measurable and is affected by the
              number of interviews and the level of the percentages expressing
              the results. For the interviews conducted in this particular
              study, the chances are 95 in 100 that a survey result does not
              vary, plus or minus, by more than 3.1 percentage points from the
              result that would be obtained if interviews had been conducted
              with all persons in the universe represented by the sample. The
              distribution of key demographic characteristics for both audiences
              were monitored during data collection, to align with available
              information provided by the CDC and NIH.
            </p>
            <p class="mb-0">
              Beyond type 1 and Sanofi do not provide medical advice, diagnosis,
              or treatment—information is provided for educational purposes
              only. Your doctor is the best source of health information. Talk
              to your doctor if you have any questions about your health or
              treatment. The survey was conducted anonymously. Respondents were
              not made aware of the survey sponsor, and no personally
              identifiable information (PII) about the respondents was shared
              with the survey sponsor. Respondents were incentivized for their
              participation, in keeping with best practice for opinion research.
            </p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
